import { getCommaSeparatedNumber } from 'components/editor/hooks/useFieldValidator';
import { ColumnTypeIdentifier, RowTypesIdentifier } from '../../../grid/reduxStore/table.types';
import { DOLLAR_SIGN } from './defaultData.tsx';

export const roundDecimalValue = (inputValue: string | number, allowedDecimalPlaces: number): string => {
  const numericValue = parseFloat(inputValue as string);
  const decimalPart = (numericValue.toString().split('.')[1] || '').length;

  if (decimalPart > allowedDecimalPlaces) {
    return numericValue.toFixed(allowedDecimalPlaces);
  }

  return numericValue.toString();
};

export function IsPricingCellWithRounding(columnType: ColumnTypeIdentifier, rowType: RowTypesIdentifier): boolean {
  return [ColumnTypeIdentifier.SUBTOTAL].includes(columnType) && rowType !== RowTypesIdentifier.HEADER;
}

export function isNumericColumn(columnType: ColumnTypeIdentifier): boolean {
  return [ColumnTypeIdentifier.SUBTOTAL, ColumnTypeIdentifier.PRICE, ColumnTypeIdentifier.MULTIPLIER].includes(columnType);
}

export const formatPriceWithDollarSign = (
  value: number | string,
  decimalPlaces: number | undefined,
  currencySign = DOLLAR_SIGN
): string => {
  let displayedValue = value.toString();

  if (decimalPlaces !== undefined) {
    displayedValue = roundDecimalValue(displayedValue, decimalPlaces);
  }

  displayedValue = `${currencySign + '' + getCommaSeparatedNumber(displayedValue)}`;

  return displayedValue;
};
